const Patient = () => {
    return(
        <>
        <div className="blueBlock">
            <h3 className="blueBlockH3">Want to help your patients access the care they deserve?</h3>
            <p className="blueBlockP">Help us address inequities in the health care system by delivering inclusive care.</p>
            <button className="blueBlockButton">Request a demo</button>
            <div className="vectorImg">
                <svg width="270" height="155" viewBox="0 0 270 155" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M269.407 1.29371C253.847 0.328826 222.445 0.382031 187.283 15.2433C135.279 37.2192 79.5112 116.755 110.386 146.7C127.85 163.639 151.123 144.734 128.756 120.695C103.252 93.2869 22.8528 102.947 0.480164 153.925" stroke="#134A45" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
        </>
    );
}

export default Patient;